// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".coupon-empty-wrapper[data-v-206c9961]{align-items:center;box-sizing:border-box;display:flex;flex-direction:column;gap:.2rem;justify-content:center;padding:.2rem 0 .4rem}.coupon-empty-wrapper .icon-empty[data-v-206c9961]{height:2.04rem;width:2.04rem}.coupon-empty-wrapper .empty-text[data-v-206c9961]{color:#000;font-size:.16rem;font-weight:500;height:.2rem;line-height:.2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
